export default __webpack_public_path__ + "static/media/corner_left.fffc2b66.png";